import React, { useEffect, useRef, useState } from 'react';
import { Clickable } from '@moda/om';
import classNames from 'classnames';
import { MobileNavV2Content } from '../MobileNavV2Content';

import './MobileNavV2Menu.scss';
import { useMobileNavigation } from '../../../hooks/useNavigation';

enum Mode {
  Resting,
  Mounted
}

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  onClose: () => void;
}

export const MobileNavV2Menu: React.FC<Props> = ({ onClose, ...rest }) => {
  const contentRef = useRef<HTMLDivElement | null>(null);
  const [mode, setMode] = useState<Mode>(Mode.Resting);

  const { data: navigator, loading } = useMobileNavigation();

  useEffect(() => {
    if (!navigator) return;

    setMode(Mode.Mounted);
  }, [navigator]);

  if (loading) {
    return null;
  }

  if (!navigator) {
    return null;
  }

  return (
    <div
      className={classNames('MobileNavV2Menu', {
        'MobileNavV2Menu--active': mode === Mode.Mounted
      })}
      {...rest}
    >
      <div className="MobileNavV2Menu__content-wrapper" ref={contentRef}>
        <MobileNavV2Content onClose={onClose} />
      </div>

      <Clickable className="MobileNavV2Menu__close" onClick={onClose} />
    </div>
  );
};
